export default {
  home: 'Pagina principală',      // Главная страница
  developers: 'Dezvoltatori',     // Застройщики
  agencies: 'Agenții',            // Агентства
  properties: 'Proprietăți',      // Объекты недвижимости
  login: 'Autentificare',         // Вход
  registration: 'Înregistrare'    // Регистрация
}